import React, { useContext, useState, useEffect } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { LabelText } from '../../components/Language';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown} from '@fortawesome/free-solid-svg-icons';
import ChangeRequestDetails from '../../components/UI/ChangeRequest/ChangeRequestDetails';
import {ChangeRequestContext} from '../context/ChangeRequestProvider';
import paginationFactory from 'react-bootstrap-table2-paginator';
import config from '../../common/const/config';
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import './index.css';
import filterFactory, { customFilter } from 'react-bootstrap-table2-filter';
import FilterOverlayTrigger from '../../components/UI/Filter/FilterOverlayTrigger';
import {parse} from 'date-fns';
import Sort from '../../components/UI/Sort/Sort';

function ChangeRequestOverviewDetails(props) { 

  const [filterData, setFilterData] = useState([]);

  const [columnFilterIndexes, setColumnFilterIndexes] = useState([]);

  const [columnFilterOptions, setColumnFilterOptions] = useState(new Map());

  const { handlerOnClearFilterClick, isClearFilter,
     handlerCrFilterApplied} = useContext(ChangeRequestContext);

  const clearFilterStateData = ()=> {
    setFilterData([]);

    setColumnFilterIndexes([]);

    setColumnFilterOptions(new Map());

    handlerOnClearFilterClick(false);
  }

  useEffect(() => {
    if(isClearFilter) 
    {
      clearFilterStateData();
    }
  }, [isClearFilter]);

  const languageContext = useContext(LanguageContext);
  const paginationLimit = config.paginationLimit;

    const tableRowStyle = () => {
      const style = {};
      style.lineHeight = "7vh";
      style.backgroundColor = '#FFFFFF';   
      return style;
    } 
   
    const options = {  
      sizePerPage: paginationLimit,
      hideSizePerPage: true,
      hidePageListOnlyOnePage: true,
      firstPageText: languageContext.labels["first"],
      prePageText: languageContext.labels["back"],
      nextPageText: languageContext.labels["next"],
      lastPageText: languageContext.labels["last"]
    }; 
  
    const statusFormatter = (statusCode) => {
      return (
            <span>
              <LabelText tid = {statusCode} />
            </span>
      );         
    }
   
    const getStatusColumnStyle = (status) => {
      return status === "status_approved" ? "status status-approved" : status === "status_declined" ? "status status-declined" : "status";
    } 

    const dateFormatter = (cell, row) => {
      return row.unblock ? null : row.revenue === null ? row.header.intakeBookMonth : row.header.revenueDate
    }

    const sortStringHandler = (a, b, order, rowA, rowB, isRemarks) => 
    {
      let aValue = a.toString().trim();
      let bValue = b.toString().trim();
      if(isRemarks && rowA && rowB)
      {  
        const aRmksCode = rowA.remarksOptionValues.filter(
          x => x.codeValueId === +a); 
        const bRmksCode = rowB.remarksOptionValues.filter(
          x => x.codeValueId === +b);  
        aValue = languageContext.labels[aRmksCode[0].codeValue.toLowerCase()];
        bValue = languageContext.labels[bRmksCode[0].codeValue.toLowerCase()];   
      }  
      return sortValue(aValue, bValue, order); 
  }   

  const sortDateHandler = (a, b, order) =>
  {
      let aValue =  parse(a, "dd/MM/yyyy", new Date());
      let bValue =  parse(b, "dd/MM/yyyy", new Date());
      return sortValue(aValue, bValue, order);
  }

  const convertToNumber = (value) => {
    return Number(
      value.replace(/\./g, "").replace(/\,/g, "."))
  }

  const sortStatusDateHandler = (a, b, order) => {
      let adate = a.split(" ");
      let bdate = b.split(" ");
      let atime = adate[1].split(":");
      let btime = bdate[1].split(":");
      atime = atime[0] + atime[1];
      btime = btime[0] + btime[1];
      let aValue = parse(adate[0], "dd/MM/yyyy", new Date());
      let bValue = parse(bdate[0], "dd/MM/yyyy", new Date());
      return sortStatusValue(aValue, bValue, atime, btime, order);
  }

  const sortStatusValue = (aValue, bValue, atime, btime, order) => { 
    if (order === 'desc') {     
        return bValue > aValue ? 1 : bValue < aValue ? -1 : bValue = aValue ? btime > atime ? 1 : btime < atime ? -1 : 0 : 0
    }          
        return aValue > bValue ? 1 : aValue < bValue ? -1 : aValue = bValue ? atime > btime ? 1 : atime < btime ? -1 : 0 : 0
  }  

  const sortNumberHandler = (a, b, order) => {
      let aValue = convertToNumber(a);
      let bValue = convertToNumber(b);

      return sortValue(aValue, bValue, order);  
  }   

  const sortValue = (aValue, bValue, order) => {
      if(aValue == 'Invalid Date' 
              && bValue == 'Invalid Date' 
              && aValue == 'Invalid Date'
              || bValue == 'Invalid Date') 
      {
        return -1
      }
      else{
      if (order === 'desc')
      {
        return bValue > aValue ? 1 
                      : bValue < aValue ? -1 : 0
      }                 
        return aValue > bValue ? 1 
                      : aValue < bValue ? -1 : 0   
    }
  } 
  
  const sortHandler = (order, column,
     isEditableColumn) => { 
    if(order && column
       && isEditableColumn === true)
      {
       const b = order.split(",");
       order = b[1] !== column.dataField? undefined : b[0];
      }         
      return (<Sort order= {order}/>)           
  }

    function userSpecificColumns (dataField, classes, textId, headerClasses, editable, index) {
      let column = props.isNmbsUser && {
       text: <LabelText tid={textId} />,
       dataField: dataField,
       classes: classes,
       headerClasses: headerClasses,
       editable: editable,
       columnIndex: index,
       filter: customFilter(),
       filterRenderer: (onFilter) => handlerFilterOverlayTrigger(column, classes,
         false, true, "header", false, false),
       sort: true, 
       sortCaret : (order) => sortHandler(
         order, column, false), 
       sortFunc: (a, b, order, rowA, rowB) => sortStringHandler(
         a, b, order, rowA, rowB, false)
      }
      return column;
    }

    const handlerFilterOverlayTrigger = (column, colName, 
      isDate, isNested, nestedObjectField, isDropdown, isRuleValue) => { 
      return (<FilterOverlayTrigger 
          column={column}
          colName={colName}
          data={props.changeRequestDetails}
          filterData={filterData}
          columnFilterIndexes={columnFilterIndexes}
          columnFilterOptions={columnFilterOptions}
          isDate={isDate}
          isNested={isNested}
          nestedObjectField={nestedObjectField}
          setColumnFilterOptions={setColumnFilterOptions}
          setFilterData={setFilterData}
          setColumnFilterIndexes={setColumnFilterIndexes}
          isDropdown={isDropdown}
          handlerCheckDetailsFilterApplied={handlerCrFilterApplied}          
          isRuleValue={isRuleValue}
      />);
  }
  
    const columns = [   
      {
        dataField: 'header.changeRequestNumber',
        text: <LabelText tid="change_id" />,
        filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(
          column, "changeRequestNumber", false, true, "header", false, false),
        classes: "changeId",
        headerClasses: "changeId-header",
        editable: false,
        columnIndex: 0,
        filter: customFilter(),
        sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(
          a, b, order, rowA, rowB, false),
        sort: true, 
        sortCaret : (order, column) => sortHandler(order, column, false)
      },
      {
        dataField: 'header.statusCode',
        text: <LabelText tid="status" />,        
        formatter: (cell) => statusFormatter(cell),
        classes : (statusValue) => getStatusColumnStyle(statusValue),
        headerClasses: "status-header",
        sortCaret : (order, column) => sortHandler(order, column, false), 
        editable: false,
        columnIndex: 1,
        filter: customFilter(),
        filterRenderer: (onFilter, 
                  column) => handlerFilterOverlayTrigger(column, "statusCode", false, true, "header", false, true),
        sort: true,        
        sortFunc: (a, b, order, dataField, rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, false)
      },
      {      
        text: <div className="statusDateTimeLabel"><LabelText tid="status_date_time"  /></div>,
        classes: "statusDateTime",
        headerClasses: "statusDateTime-header",
        editable: false,
        columnIndex: 2,
        dataField: 'header.submittedDateTime',
        sortCaret : (order, column) => sortHandler(order, column, false),
        filter: customFilter(),
        filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(
          column, "submittedDateTime", true, true, "header", false, false),
        sort: true,
        sortFunc: (a, b, order) => sortStatusDateHandler(a, b, order)
      },
      userSpecificColumns('header.businessPartnerName', 'businessPartnerName',"businesspartner_payername",
      "businessPartnerName-header", false, 3),      
      userSpecificColumns('header.concessionName', 'concessionName',"concessionname",
      "concessionName-header", false, 4),
      userSpecificColumns('header.stationName', 'stationName',"station",
      "stationnName-header", false, 5),
      {
        dataField: 'header.revenueDate',      
        classes: "revenueDate",
        headerClasses: "revenueDate-header",
        text: <LabelText tid="revenue_date_month" />,
        editable: false,
        filterRenderer: (onFilter, 
                          column) => handlerFilterOverlayTrigger(
                            column, "revenueDate", true, true, "header", false, false),
        formatter : (cell, row) => dateFormatter(cell, row),
        columnIndex: 6,
        filter: customFilter(),        
        sort: true,
        sortCaret : (order, column) => sortHandler(order, column, false),   
        sortFunc: (a, b, order) => sortDateHandler(a, b, order)
      },
      {
        dataField: 'header.contractCode',      
        classes: "contractCode",
        text: <LabelText tid="contractcode" />,
        headerClasses: "contractCode-header",
        editable: false,
        columnIndex: 7,
        filter: customFilter(),
        filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(
          column, "contractCode", false, true, "header",  false, false),
        sortFunc: (a, b, order) => sortNumberHandler(a, b, order),
        sort: true,
        sortCaret : (order, column) => sortHandler(order, column, false)        
      },
      {
        dataField: 'header.businessPartnerCode',
        text: <LabelText tid="businesspartnercode" />, 
        filterRenderer: (onFilter, 
          column) => handlerFilterOverlayTrigger(column, "businessPartnerCode", false, true, "header",  false, false),
        headerClasses: "businessPartnerCode-header",
        classes: "businessPartnerCode",
        editable: false,
        columnIndex: 8,
        filter: customFilter(),               
        sortCaret : (order, column) => sortHandler(order, column, false), 
        sort: true, 
        sortFunc: (a, b, order, dataField,
           rowA, rowB) => sortStringHandler(a, b, order, rowA, rowB, false)
      },
    ];
  
    
    const expandRow = {
      renderer: row => (
        <div className="row">       
          <div className="expanded-renderer-column"/>  
            <div className="expanded-renderer-content">
              <ChangeRequestDetails 
                data = {row}
                remarksOptions = {props.remarksOptions}
                isEditAccess={props.isEditAccess}
                filterData={filterData}
                setFilterData={setFilterData}
                isNmbsUser={props.isNmbsUser}
                 /> 
            </div>          
        </div> 
      ),
      showExpandColumn: true,  
      expandColumnRenderer: ({ expanded }) => {   
        return <FontAwesomeIcon className="fa-arrow" icon = {expanded ? faChevronDown : faChevronUp} />  
      },
      expandByColumnOnly: true,
      onlyOneExpanding: true,
    }  
  

    return (
        <BootstrapTable
        keyField='header.changeRequestNumber'
        data={filterData 
                && filterData.length > 0
                 ? filterData
                 : props.changeRequestDetails}
        columns={columns.filter(c=>c)}        
        bordered
        noDataIndication={<LabelText tid="no_change_request" />}
        rowStyle={tableRowStyle}
        classes={"change-request-overview-datatable row scroller"}
        filter={filterFactory()}
        headerClasses={"change-request-overview-datatable-header"} 
        expandRow={expandRow} 
        pagination={ props.changeRequestDetails.length > paginationLimit ? paginationFactory(options) : undefined }                   
      />
    )
}

export default ChangeRequestOverviewDetails;
